import { render, staticRenderFns } from "./SurnameForm.vue?vue&type=template&id=793b8b54&scoped=true"
import script from "./SurnameForm.vue?vue&type=script&lang=js"
export * from "./SurnameForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793b8b54",
  null
  
)

export default component.exports